module.exports = __webpack_public_path__ + "ef11e080.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Avatar/user-solid.svg
// module id = 2759
// module chunks = 15